import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// core material components
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import MoreHoriz from '@material-ui/icons/MoreHoriz';
import MoreVert from '@material-ui/icons/MoreVert';
import { Box, makeStyles, Tooltip } from '@material-ui/core';
import Spinner from 'components/Spinner';

// makeStyles
const useStyles = makeStyles({
  main: {
    position: 'absolute',
    right: '0px',
    top: '0px',
  },
  // Disabled MenuItems do not fire pointer events, so wrap them in a span that
  // can receive hover and show option.tooltip.
  tooltipWrap: {
    display: 'block',
  },
});

const SelectMenu = ({ options, menuContainerClassName, menuBtnClassName, isVerticalIcon }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={cx(classes.main, menuContainerClassName)}>
      <IconButton className={menuBtnClassName} onClick={handleClick}>
        {isVerticalIcon ? <MoreVert /> : <MoreHoriz />}
      </IconButton>

      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        {options.map((option, idx) => {
          const menuItem = (
            <MenuItem
              disabled={option.disabled}
              onClick={event => {
                // Skip handlers for disabled items (MUI usually blocks this, but be explicit).
                if (option.disabled) {
                  return;
                }
                // Forward the click event so handlers can call preventDefault when needed.
                option.onItemClick(event);
                setAnchorEl(null);
              }}
            >
              <Box style={{ display: 'flex', alignItems: 'center' }}>
                {option.title}
                {option.loading && (
                  <Box ml={1} style={{ opacity: '0.5' }}>
                    <Spinner size={14} color="inherit" />
                  </Box>
                )}
              </Box>
            </MenuItem>
          );

          // Tooltip only when provided. Span wrapper is required so hover works on disabled items.
          if (option.tooltip) {
            return (
              <Tooltip
                key={idx.toString()}
                title={option.tooltip}
                placement="left"
                enterDelay={300}
              >
                <span className={classes.tooltipWrap}>{menuItem}</span>
              </Tooltip>
            );
          }

          return <React.Fragment key={idx.toString()}>{menuItem}</React.Fragment>;
        })}
      </Menu>
    </div>
  );
};

SelectMenu.propTypes = {
  options: PropTypes.array.isRequired,
  menuContainerClassName: PropTypes.string,
  menuBtnClassName: PropTypes.string,
};

export default SelectMenu;
